import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = +new Date(targetDate) - +new Date();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const TimeUnit = ({ value, label }) => (
    <div className="flex flex-col items-center">
      <div className="bg-red-600 text-white text-3xl md:text-4xl font-bold px-4 py-3 rounded-lg min-w-[70px] text-center">
        {String(value).padStart(2, '0')}
      </div>
      <span className="text-gray-600 text-sm mt-2 font-medium">{label}</span>
    </div>
  );

  return (
    <div className="flex items-center justify-center gap-4 md:gap-6">
      <TimeUnit value={timeLeft.days} label="Gün" />
      <span className="text-3xl text-red-600 font-bold">/</span>
      <TimeUnit value={timeLeft.hours} label="Saat" />
      <span className="text-3xl text-red-600 font-bold">/</span>
      <TimeUnit value={timeLeft.minutes} label="Dakika" />
      <span className="text-3xl text-red-600 font-bold">/</span>
      <TimeUnit value={timeLeft.seconds} label="Saniye" />
    </div>
  );
};

export default CountdownTimer;
